const { ethers } = require("ethers");

// Polygon Mainnet RPC (Settlement Chain)
const POLYGON_MAINNET_RPC = "https://polygon-bor-rpc.publicnode.com";
const POLYGON_MAINNET_WSS = "wss://polygon-bor-rpc.publicnode.com";

const getPublicProvider = () => {
  // Always use Polygon mainnet for the settler contract
  const publicprovider = new ethers.JsonRpcProvider(POLYGON_MAINNET_RPC);

  let webSocketProvider;
  try {
    webSocketProvider = new ethers.WebSocketProvider(POLYGON_MAINNET_WSS);
  } catch (e) {
    // Fallback to HTTP provider if WebSocket fails
    webSocketProvider = publicprovider;
  }

  // Public signer for read-only operations
  const publicSigner = new ethers.VoidSigner(
    process.env.REACT_APP_PUBLIC_SIGNER_ADDRESS || "0x0000000000000000000000000000000000000000",
    publicprovider
  );

  return { publicSigner, publicprovider, webSocketProvider };
};

export default getPublicProvider;
